import { TextBlockProps } from "@made-people/blueprint-text-block";

/**
 * In this file you can specify default props for components that render,
 * which have been wrapped with withManagedProps
 */

export const TextBlock: TextBlockProps = {
  layout: {
    spacing: {
      y: {
        initial: "2xl",
        md: "3xl",
        lg: "3xl",
      },
    },
  },
};
